import apicore from '@/helpers/apicore';
import { adaptMaps } from '@/helpers/apicore/adapters';
import dataStore from '@/helpers/data';
import helperError from '@/helpers/error';
import language from '@/helpers/language';

const state = {
  maps: {
    grouped: [],
    select: [],
  },
  ready: true,
  type: 'random',
  selected: '',
  timer: {
    time: 1800, //600,
    update: null,
  },
  paused: false,
};

const getters = {
  map: (state) => state,
};

const actions = {
  reset({ commit }) {
    commit('SET_READY', false);
    commit('SET_TYPE', 'random');
    commit('SET_SELECTED', '');
  },
  updating({ commit }) {
    commit('SET_PAUSED', false);
  },
  ready({ commit }, mode) {
    commit('SET_READY', mode);
  },
  async maps({ commit }) {
    const data = dataStore.getter(this.getters);
    this.dispatch('app/loading', true);
    return await apicore.get('gathers/' + data.gather.info.id + '/available-maps').then(
      (response) => {
        this.dispatch('app/loading', false);
        const groups = response && response.data && response.data.groups ? response.data.groups : [];
        const grouped = adaptMaps(groups);
        const list = [];
        grouped.forEach((group) => {
          group.maps.forEach((map) => {
            list.push({ group: { id: group.mapGroupId, name: group.name }, map: { id: map.mapId, name: map.name, workshopId: map.workshopId } });
          });
        });
        commit('SET_MAPS_GROUPED', grouped);
        commit('SET_MAPS_SELECT', list);
        commit('SET_READY', true);
      },
      (error) => {
        helperError(this, error, language(data.language.current)['errorOccured']);
      }
    );
  },
  type({ commit }, parameter) {
    commit('SET_PAUSED', false);
    // F9: the mapSelection TYPE (random|voting|oscar, R16) has no C2 write path — the
    // legacy PATCH /gather/{token} {key:'mapSelection'} route is gone, and the selector
    // only enables 'random' (voting/oscar are commented out in SettingsGather.vue), so
    // the write is unreachable UI. Commit the type locally for both send:true/false.
    commit('SET_TYPE', parameter.type);
  },
  async selected({ commit }, parameter) {
    this.dispatch('map/updating');
    let mapString = '';
    if (parameter.send) {
      let input = '';
      if (input.name !== undefined) {
        mapString += parameter.name;
      } else {
        parameter.maps.forEach((map, i) => {
          if (i > 0) {
            mapString += ',';
          }
          mapString += map.name;
        });
      }

      const data = dataStore.getter(this.getters);
      let item = { key: 'map', value: { name: 'Map', type: 'map', value: mapString } };
      this.dispatch('gather/update', { token: data.gather.info.token, item: item });
    } else {
      mapString = parameter.maps;
    }
    commit('SET_SELECTED', mapString);
  },
};

const mutations = {
  SET_MAPS_GROUPED(state, payload) {
    state.maps.grouped = payload;
  },
  SET_MAPS_SELECT(state, payload) {
    state.maps.select = payload;
  },
  SET_READY(state, mode) {
    state.ready = mode;
  },
  SET_TYPE(state, type) {
    state.type = type;
  },
  SET_SELECTED(state, maps) {
    state.selected = maps;
  },
  SET_PAUSED(state, parameter) {
    state.paused = parameter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
